export enum THEME_FIELDS {
	STATE = "state",
	LIGHT = "light",
	DARK = "dark",
}
